/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useMemo, useRef, useState } from "react";

/** Common Components */
import Buttons from "../../../../components/ui/button/Buttons";
import Label from "../../../../components/finalForms/ui/label/Label";
import FinalMolGrid from "../../../../components/FinalMolGrid/FinalMolGrid";
import DropdownSelect from "../../../../components/finalForms/ui/inputs/dropdown/DropdownSelect";

/** Common Services & Data Files */
import SwalAlert from "../../../../services/swalService/SwalService";
import ToastService from "../../../../services/toastService/ToastService";
import { getTeamPlanningMessageType, isTeamPlanningSuccessMessage } from "../../utils/teamPlanningResponse";

/** Configuration Files */
import { editableMolGridConfig } from "../resourcePlanning/config/ResoucePlanning.data";

/** RTK Query */
import {
  useLazyGetAllResourcePlanningListQuery,
  useLazyGetUnassignedTeamResourceQuery,
  useAssignedTeamResourceMemberMutation
} from "../../../../app/services/teamPlanningAPI";
import { useDeleteteamResourceplanningMutation, useUpdateteamResourceplanningMutation } from "../../../../app/services/teamResourcePlanningAPI";

const PlanningTeamMembers = (props) => {

  let teamPlanningId = null;
  let teamId = null;

  const molGridRef = useRef();

  const [teamData, setTeamData] = useState([]);
  const [selectedTeam, setSelectedTeam] = useState(null);
  const [teamMemberGridData, setTeamMemberGridData] = useState();
  const isReadOnly = props.isReadOnly === true;

  teamPlanningId = props?.planningId;
  teamId = props?.teamId;

  const { confirm } = SwalAlert();

  const [getAllResourcePlanning, {
    isLoading: isResourcePlanningListLoading,
    isSuccess: isResourcePlanningListSuccess,
    data: isResourcePlanningListData,
  },] = useLazyGetAllResourcePlanningListQuery();

  const [getUnassignedTeamResource, {
    isFetching: isUnAssignedTeamResourceFetching,
    isSuccess: isUnAssignedTeamResourceSuccess,
    data: UnAssignedTeamResourcedata,
  },] = useLazyGetUnassignedTeamResourceQuery();

  const [assignedTeamResourceMember, {
    isSuccess: isAssignedTeamResourceMemberAdded,
    isLoading: isassignedTeamResourceMemberAdding,
    data: AssignedTeamResourceMemberData,
  }] = useAssignedTeamResourceMemberMutation();

  const [updateteamResourceplanning, {
    isLoading: isTeamResourcePlanningUpdating,
    isSuccess: isResourcePlanningUpdated,
    data: ResourcePlanningData,
  },] = useUpdateteamResourceplanningMutation();

  const [deleteTeamPlanning, {
    isSuccess: isTeamPlanningDeleted,
    data: deleteTeamPlanningData
  },] = useDeleteteamResourceplanningMutation();

  const getUnassignedTeamMember = () => {
    const request = {
      teamId: teamId,
      planningId: teamPlanningId
    }
    getUnassignedTeamResource(request);
  }

  useEffect(() => {
    if (isResourcePlanningUpdated && ResourcePlanningData) {
      const message = ResourcePlanningData.errorMessage;
      ToastService[getTeamPlanningMessageType(message)](message);
      if (!isTeamPlanningSuccessMessage(message)) return;

      getteamMemberList();
      if (props.onPlanningDataChanged) {
        props.onPlanningDataChanged();
      } else if (props.getResourceTotalPlanningCount) {
        props.getResourceTotalPlanningCount({
          teamId: teamId,
          planningId: teamPlanningId,
        });
      }
    }
  }, [isResourcePlanningUpdated, ResourcePlanningData]);

  const handleEditClick = (newSelectedOptions, index) => {
    if (isReadOnly) return;

    if (newSelectedOptions) {
      updateteamResourceplanning({
        workingDays: Number(newSelectedOptions.workingDays),
        resourcePlanningId: teamMemberGridData?.[index].resourcePlanningId,
        teamId: teamId,
        planningID: teamPlanningId,
        userId: teamMemberGridData?.[index].userId,
        productive: Number(newSelectedOptions.productive),
      });
    }
  };


  useEffect(() => {
    if (isTeamPlanningDeleted && deleteTeamPlanningData) {
      const message = deleteTeamPlanningData.errorMessage;
      ToastService[getTeamPlanningMessageType(message)](message);
      if (!isTeamPlanningSuccessMessage(message)) return;

      const req = {
        teamId: teamId,
        planningId: teamPlanningId,
      }
      if (props.onPlanningDataChanged) {
        props.onPlanningDataChanged();
      } else if (props.getResourceTotalPlanningCount) {
        props.getResourceTotalPlanningCount(req);
      }
      getteamMemberList();
      getUnassignedTeamMember();
    }
  }, [isTeamPlanningDeleted, deleteTeamPlanningData]);

  const handleDelete = (data) => {
    if (isReadOnly) return;
    confirm(
      "Delete?",
      "Are you sure you want to Delete?",
      "Delete",
      "Cancel"
    ).then((confirmed) => {
      if (confirmed) {
        const req = {
          userId: data.userId,
          resourcePlanningId: data.resourcePlanningId,
          teamId: teamId,
        }
        deleteTeamPlanning(req);
      }
    });
  };

  useEffect(() => {
    getUnassignedTeamMember();
  }, []);

  useEffect(() => {
    if (!isUnAssignedTeamResourceFetching && isUnAssignedTeamResourceSuccess && UnAssignedTeamResourcedata) {
      if (UnAssignedTeamResourcedata) {
        const dropdownData = UnAssignedTeamResourcedata.map((item) => ({
          value: item.userId,
          label: item.userName,
        }));
        setTeamData(dropdownData);
      }
    }
  }, [isUnAssignedTeamResourceFetching, isUnAssignedTeamResourceSuccess, UnAssignedTeamResourcedata]);

  const getteamMemberList = () => {
    const request = {
      teamId: teamId,
      planningId: teamPlanningId,
    };
    getAllResourcePlanning(request);
  };

  useEffect(() => {
    getteamMemberList();
  }, [])

  useEffect(() => {
    if (isResourcePlanningListSuccess && isResourcePlanningListData) {
      if (isResourcePlanningListData) {
        setTeamMemberGridData(isResourcePlanningListData);
      }
    }
  }, [isResourcePlanningListSuccess, isResourcePlanningListData]);

  useEffect(() => {
    if (isAssignedTeamResourceMemberAdded && AssignedTeamResourceMemberData) {
      const message = AssignedTeamResourceMemberData.errorMessage;
      const messageType = getTeamPlanningMessageType(message);

      if (!isTeamPlanningSuccessMessage(message)) {
        ToastService[messageType](message);
        return;
      } else {
        ToastService.success(message);
        const req = {
          teamId: teamId,
          planningId: teamPlanningId,
        }
        if (props.onPlanningDataChanged) {
          props.onPlanningDataChanged();
        } else if (props.getResourceTotalPlanningCount) {
          props.getResourceTotalPlanningCount(req);
        }
        setSelectedTeam(null);
        getteamMemberList();
        getUnassignedTeamMember();
      }
    }
  }, [isAssignedTeamResourceMemberAdded, AssignedTeamResourceMemberData]);

  const handleSubmit = () => {
    if (isReadOnly) return;
    if (!selectedTeam) {
      ToastService.warning("Please select a team member");
      return;
    }
    const teamMember = selectedTeam.map((item) => (item.value.toString())).join(",");
    const request = {
      teamId: teamId,
      planningId: teamPlanningId,
      userIds: teamMember
    };
    assignedTeamResourceMember(request);
  };

  const handalDropDownChange = (newValue) => {
    setSelectedTeam(newValue);
  };

  const actionHandler = {
    DELETE: handleDelete,
    EDIT: handleEditClick
  };

  const gridConfig = useMemo(() => {
    if (!isReadOnly) {
      return editableMolGridConfig;
    }

    return {
      ...editableMolGridConfig,
      allowEdit: false,
      columns: editableMolGridConfig.columns.map((column) => ({
        ...column,
        allowEditColumn: false,
        defaultAction: column.defaultAction
          ? { allowEdit: false, allowDelete: false }
          : column.defaultAction,
      })),
    };
  }, [isReadOnly]);

  return (
    <div>
      {!isReadOnly && <div className="row">
        <div className="col-6">
          <div className="myteam-members">
            <Label labelName="Team Members :" isRequired={true} />
            <div className="myteam-dropdown">
              <DropdownSelect
                isMultiSelect={true}
                value={selectedTeam}
                optionsValue={teamData}
                placeholder={"Please Select Team Members"}
                handleDropdownChange={handalDropDownChange}
              />
              <div className="myteam-members-addbtn">
                <Buttons
                  buttonTypeClassName="theme-btn"
                  isDisable={!selectedTeam || selectedTeam.length === 0}
                  isLoading={isTeamResourcePlanningUpdating || isassignedTeamResourceMemberAdding}
                  onClick={handleSubmit}
                  buttonText="Team Member"
                  textWithIcon={true}
                  iconName="material-symbols:add-rounded"
                  fontIcon={true}
                />
              </div>
            </div>
          </div>
        </div>
      </div>}
      <div className="myteam-members-list last-col-remove">
        <Label labelName="Planning Team :" />
        <FinalMolGrid
          ref={molGridRef}
          dataSource={teamMemberGridData}
          configuration={gridConfig}
          isLoading={isResourcePlanningListLoading}
          onRowDataUpdate={handleEditClick}
          allowPagination={false}
          pagination={{
            // totalCount: totalRowCount,
            pageSize: 10,
            currentPage: 1,
          }}
          // onPageChange={handlePageChange}
          //   onRowDataUpdate={handleEditClick}
          //   allowPagination={false}
          onActionChange={isReadOnly ? {} : actionHandler}
        />
      </div>
    </div>
  );
};

export default PlanningTeamMembers;
